import { render, staticRenderFns } from "./CommonImageUpload.vue?vue&type=template&id=0403be2c&scoped=true"
import script from "./CommonImageUpload.vue?vue&type=script&lang=js"
export * from "./CommonImageUpload.vue?vue&type=script&lang=js"
import style0 from "./CommonImageUpload.vue?vue&type=style&index=0&id=0403be2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403be2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0403be2c')) {
      api.createRecord('0403be2c', component.options)
    } else {
      api.reload('0403be2c', component.options)
    }
    module.hot.accept("./CommonImageUpload.vue?vue&type=template&id=0403be2c&scoped=true", function () {
      api.rerender('0403be2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/submit-form/components/CommonImageUpload.vue"
export default component.exports